//Author : Rohan Patel
//
export const baseURL = "https://wayorder.herokuapp.com";
